import React from "react"
import "./Badge.css"

export type Vertical = "top" | "middle" | "bottom"
export type Horizontal = "left" | "center" | "right"
export type Quadrant = "I" | "II" | "III" | "IV"
export type BadgeStyle = "info" | "success" | "warning" | "error"

interface BadgeProps extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
    badge?: JSX.Element,
    badgeStyle?: BadgeStyle & string,
    vertical?: Vertical,
    horizontal?: Horizontal,
    quadrant?: Quadrant,
    transform?: boolean,
    transformYOnly?: boolean,
    transformXOnly?: boolean,
}

export default function Badge(props: BadgeProps) {
    const vertical = ["top", "middle", "bottom"].includes(props.vertical ? props.vertical : "") ?
        props.vertical : "top"
    const horizontal = ["left", "center", "right"].includes(props.horizontal ? props.horizontal : "") ?
        props.horizontal : "right"
    const quadrant = ["I", "II", "III", "IV"].includes(props.quadrant ? props.quadrant : "") ?
        props.quadrant : "III"

    const getTransformClassName = () => {
        const transform = (props.transform === undefined) ? true : props.transform
        if (transform === false) {
            return ""
        }

        if (props.transformYOnly) {
            return "transformY-" + quadrant
        } else if (props.transformXOnly) {
            return "transformX-" + quadrant
        } else {
            return "transform-" + quadrant
        }
    }

    const getBadgeClassName = () => {
        return [
            "badge",
            vertical + "-" + quadrant,
            horizontal + "-" + quadrant,
            getTransformClassName()
        ].join(" ").replaceAll("  ", " ").trim()
    }

    const getBadge = () => {
        return <>
            {
                props.badge &&
                <div className={getBadgeClassName()}>
                    <div className={"badge-content" + (props.badgeStyle ? (" " + props.badgeStyle) : "")}>
                        {props.badge}
                    </div>
                </div>
            }
        </>
    }

    return (
        <>
            {
                props.children ?
                    <div className="position-relative">
                        {props.children}
                        {getBadge()}
                    </div>
                    :
                    <div className="base">
                        {getBadge()}
                    </div>
            }
        </>
    )
}
